import { get, post } from "../base.ehq.model";
import { serialize } from "./quick-poll.serializer";
import { deserialize } from "../base.serializer";

export const getQuickPoll = async (
  token,
  baseUrl,
  projectId,
  quickPollId,
  config = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/quick_polls/${quickPollId}`;
  try {
    const res = await get(token, queryPath, {}, config);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};

export const setQuickPoll = async (
  token,
  baseUrl,
  projectId,
  quickPollId,
  body = {}
) => {
  const queryPath = `${baseUrl}/projects/${projectId}/quick_polls/${quickPollId}/responses`;
  try {
    const serializedBody = serialize(body);
    const res = await post(token, queryPath, serializedBody);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
